export const paths =
{
    languagesFile: "/assets/languages.json",
    languagesDyoFile: "/assets/languagesDyo.json",
    localizationPath: "/assets/i18n",
    logsUrl: "/api/logs",
    endpointsUrl: "/api/endpoints",
};
